import { useMemo } from "react"
import HomeLayout from "modules/home-layout"
import useContextDashboard from "./context/dashboard"
import PreferenceContext from "hooks/preferences"
import { useAccountId } from "resources/account"
import Loading from "components/loading"
import { useClearDashboardPreferences } from "./hooks/use-clear-dashboard-preferences"
import { AiContext } from "connected-components/ai-teammate/context/ai-context"

function DashboardWithPreferences({ children }) {
  // This needs to be done here it needs to be a child of the PreferenceContext.Provider for the usePreferences hook to work
  const [Context, contextValue] = useContextDashboard()

  const aiContextValue = useMemo(() => ({
    modelId: contextValue.modelId,
    instrument: contextValue.instrument,
    base: contextValue.base,
    startDate: contextValue.startDate,
    endDate: contextValue.endDate,
    isPreferencesLoaded: contextValue.isPreferencesLoaded,
    canPinArtifacts: true,
  }), [
    contextValue.modelId,
    contextValue.instrument,
    contextValue.base,
    contextValue.startDate,
    contextValue.endDate,
    contextValue.isPreferencesLoaded,
  ])

  return (
    <Context.Provider value={contextValue}>
      <AiContext.Provider value={aiContextValue}>
        {children}
      </AiContext.Provider>
    </Context.Provider>
  )
}

export default function DashboardHomeLayout() {
  const accountId = useAccountId()

  // Check for clearPreferences URL param and handle clearing BEFORE any dashboard queries
  // This must be called before the PreferenceContext.Provider to ensure preferences are cleared before they are loaded
  const { isClearing: isPreferencesClearing } = useClearDashboardPreferences()

  const preferencesProps = useMemo(() => ({
    accountId,
    // Since we can only have one dashboard per account, there is no need to have a more complex key.
    // Each context will append its unique identifier to the key.
    // eg. dashboard.asset-view, dashboard.kpi, dashboard.factors-view
    key: "dashboard",
    type: "dashboard",
  }), [accountId])

  if (isPreferencesClearing) {
    return <Loading />
  }

  return (
    <PreferenceContext.Provider value={preferencesProps}>
      <DashboardWithPreferences>
        <HomeLayout />
      </DashboardWithPreferences>
    </PreferenceContext.Provider>
  )
}
